export default __webpack_public_path__ + "static/media/My-Portfolio-Project.417d0f60.PNG";